// Simulated global activity feed for the landing page.
// The counter is time-anchored so it always moves forward, and the events are
// synthetic: no real user file ever reaches a server.
const ANCHOR_BASE = 4317;
const PER_HOUR = 1000;
const PER_SECOND = PER_HOUR / 3600;

const startOfDay = () => {
  const d = new Date();
  d.setUTCHours(0, 0, 0, 0);
  return d.getTime();
};

export function liveCount(realCount = 0) {
  const elapsed = Math.max(0, (Date.now() - startOfDay()) / 1000);
  return ANCHOR_BASE + Math.floor(elapsed * PER_SECOND) + realCount;
}

export const PER_MINUTE = PER_HOUR;

const NAMES = [
  "capture", "visual", "render", "draft", "photo", "affiche", "mockup", "scan",
  "portrait", "brief", "rapport", "deck", "asset", "poster", "cover", "note",
  "shot", "planche", "memo", "concept",
];
const EXTS = ["png", "jpg", "pdf", "docx", "svg", "md", "webp", "txt", "html"];
const MARKS = ["c2pa", "synthid", "exif", "xmp", "unicode", "docprops", "statistical", "jumbf"];
const REGIONS = ["FR", "BE", "CH", "CA", "US", "DE", "ES", "UK", "NL", "IT", "PT", "JP"];

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

let seq = 0;

export function makeEvent() {
  const ext = pick(EXTS);
  return {
    id: ++seq,
    file: `${pick(NAMES)}-${Math.floor(Math.random() * 9000 + 1000)}.${ext}`,
    mark: pick(MARKS),
    region: pick(REGIONS),
    marks: Math.floor(Math.random() * 9) + 1,
    at: Date.now(),
  };
}
